document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sub-faqs').forEach(function (faqRoot) {
    const headers = Array.from(faqRoot.querySelectorAll('.sub-faq-inner'));

    // Animation is pure CSS (grid 0fr<->1fr + opacity); JS just toggles state.
    function toggle(button, open) {
      const content = document.getElementById(button.getAttribute('aria-controls'));
      const expand = button.querySelector('.sub-faq-expand');
      const item = button.closest('.sub-faq');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (expand) expand.classList.toggle('expanded', open);
      if (content) content.classList.toggle('expanded', open);
      // Expose the open state on the .sub-faq item so it can be styled.
      if (item) item.classList.toggle('sub-faq-expanded', open);
    }

    headers.forEach(function (button, index) {
      // Native <button> handles Enter/Space.
      button.addEventListener('click', function () {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        toggle(button, !isOpen);
      });

      // The button only spans the card's content box, so the card's padding ring
      // was dead space. Widen the hit area to the whole .sub-faq by forwarding
      // its clicks to the button, which stays the real control for a11y.
      const item = button.closest('.sub-faq');
      if (item) {
        item.addEventListener('click', function (event) {
          // The button fires its own handler above; this would double-toggle it
          // back to where it started.
          if (event.target.closest('.sub-faq-inner')) return;
          // Leave real controls in the answer (the CTA link) alone.
          if (event.target.closest('a, button, input, select, textarea, label')) return;
          // Finishing a text selection inside the answer is a read, not a click.
          const selection = window.getSelection();
          if (selection && !selection.isCollapsed && item.contains(selection.anchorNode)) return;

          const isOpen = button.getAttribute('aria-expanded') === 'true';
          toggle(button, !isOpen);
        });
      }

      button.addEventListener('keydown', function (event) {
        let target = null;
        switch (event.key) {
          case 'ArrowDown':
            target = headers[Math.min(index + 1, headers.length - 1)];
            break;
          case 'ArrowUp':
            target = headers[Math.max(index - 1, 0)];
            break;
          case 'Home':
            target = headers[0];
            break;
          case 'End':
            target = headers[headers.length - 1];
            break;
          default:
            return;
        }
        if (target) {
          event.preventDefault();
          target.focus();
        }
      });
    });
  });
});
